<template lang="pug">
  v-btn.v-btn--is-elevated(
    :key="`bottomActivator`"
    ref="buttonRef"
    fixed
    bottom
    right
    @click="onClick"
    color="primary"
    rounded
    :loading="loading"
    :style="style"
    style="height: 56px; min-width: 0; z-index: 205"
    v-glass=".7")
    v-icon(
      :size="24"
      :left="!shouldCollapse") {{ $get(bottomShortcut, `action.icon`) }}
    span(
      ref="labelRef"
      style="overflow: hidden") {{ $get(bottomShortcut, `action.label`) }}
</template>

<script>
import { computed, watch, ref, onMounted, onUnmounted } from '@vue/composition-api'
import useWindow from '@iez/lib/use-window/'
import gsap from 'gsap'
import UtilityActionState from '@iez/components/utility/action-state/'
import { state as blockingMenuState } from '../../../blocking-menu/'
import { state as stateBottomNavigation } from '../../../bottom-navigation/'
import { state as stateBottomSnackbar } from '../../../bottom-snackbar/'

export default {
  components: {
    UtilityActionState
  },

  props: {
    bottomShortcut: Object
  },

  setup (props) {
    const offset = computed(
      () => [
        stateBottomNavigation.isActive,
        stateBottomSnackbar.snackbar
      ].reduce((previous, current) => previous + (current ? 52 : 0), 0)
    )

    const style = computed(() => ({
      transition: 'transform .2s cubic-bezier(0.4, 0.0, 0.2, 1)',
      transform: offset.value
        ? `translate3D(0, -${offset.value}px, 0)`
        : undefined
    }))

    const loading = ref(false)
    const buttonRef = ref(null)
    const containerRef = ref(null)
    const labelRef = ref(null)
    const window = useWindow()
    const shouldCollapse = computed(
      () =>
        (blockingMenuState.scrollTop ?? window.scrollY)
          > 100 ||
        loading.value
    )

    let timeline = null
    onUnmounted(() => {
      if (timeline) {
        timeline.kill()
      }
    })

    onMounted(() => {
      const { $el: button } = buttonRef.value
      const label = labelRef.value
      const container = containerRef.value

      const width = button.offsetWidth
      const duration = .2
      timeline = gsap.timeline({
        defaults: {
          duration,
          ease: `sine.out`
        },
        paused: true
      }).to(
        label, {
          opacity: 0,
          width: 0
        },
        0
      ).to(
        button, {
          width: 56
        },
        0
      )
      watch(
        () => shouldCollapse.value,
        shouldCollapse => {
          if (shouldCollapse) {
            timeline.play()
          } else {
            timeline.reverse()
          }
        }, {
          immediate: true
        }
      )
    })

    const onClick = () => {
      const result = props.bottomShortcut.action.onClick()
      if (result?.then) {
        loading.value = true
        result.then(() => {
          loading.value = false
        })
      }
    }

    return {
      shouldCollapse,
      buttonRef,
      containerRef,
      labelRef,
      loading,
      onClick,
      style
    }
  }
}
</script>